module.exports = __webpack_public_path__ + "img/lit_buy_and_burn.85086070.png";